import type { TaxPayerDto } from "../core/api/use-get-fulfilment-tax-payers/TaxPayerDto";
import { isAlphaNumeric } from "./stringUtils";

export const getTaxPayerIdentifier = ({
    businessName,
    name,
    surname,
    taxIdentifier,
    vatIdentifier,
}: TaxPayerDto) => {
    if (businessName) return businessName;
    if (name && surname) return `${name} ${surname}`;
    return `${taxIdentifier.toUpperCase()} - ${vatIdentifier.toUpperCase()}`;
};

export const isFiscalCode = (value: string) => {
    return !!value && isAlphaNumeric(value) && value.length === 16;
};
